var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Error Big White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Error-Big-White",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-sms_failed-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 90 0 90 90 0 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,7 L14.5,7 C10.375,7 7.0375,10.375 7.0375,14.5 L7,82 L22,67 L74.5,67 C78.625,67 82,63.625 82,59.5 L82,14.5 C82,10.375 78.625,7 74.5,7 Z M48.25,52 L40.75,52 L40.75,44.5 L48.25,44.5 L48.25,52 Z M48.25,37 L40.75,37 L40.75,22 L48.25,22 L48.25,37 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWhite);
export default __webpack_public_path__ + "static/media/error-white.f8ded8514fc29d7409bb0b9abccb40b0.svg";
export { ForwardRef as ReactComponent };